import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

const UnderConstructionPage = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      background: 'linear-gradient(to bottom, #F0F7FF, #E1EFFE)'
    },
    content: {
      maxWidth: '32rem',
      margin: '0 auto',
      textAlign: 'center'
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: '2rem'
    },
    iconWrapper: {
      width: '40px',
      height: '40px',
      color: '#ffd750',
      animation: 'bounce 1s infinite'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#1F2937',
      marginBottom: '1rem'
    },
    subtitle: {
      fontSize: '1.25rem',
      color: '#4B5563',
      marginBottom: '2rem'
    },
    statsContainer: {
      background: 'white',
      borderRadius: '0.5rem',
      padding: '1.5rem',
      marginBottom: '2rem',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '1rem'
    },
    statBox: {
      padding: '1rem'
    },
    statNumber: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
      color: '#2563EB'
    },
    statLabel: {
      color: '#4B5563'
    },
    button: {
      backgroundColor: '#ffd750',
      color: 'black',
      padding: '0.5rem 1.5rem',
      borderRadius: '9999px',
      textDecoration: 'none',
      transition: 'background-color 0.3s'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <ScrollAnimation animateIn="fadeIn" duration={1}>
          <div style={styles.iconContainer}>
            <div style={styles.iconWrapper}>
              <svg 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                style={{ width: '100%', height: '100%' }}
              >
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
              </svg>
            </div>
          </div>
          
          <h1 style={styles.title}>
            Sitio en Construcción
          </h1>
          
          <p style={styles.subtitle}>
            Estamos trabajando para traerte algo increíble.<br/>
            ¡Vuelve pronto!
          </p>

          <div>
            <p style={styles.statLabel}>
              Mientras tanto, puedes contactarnos en: <a href="mailto:contacto@comercialwin.cl">contacto@comercialwin.cl</a>
            </p>
            <div style={{ marginTop: '1rem' }}>
              <a 
                href="mailto:contacto@comercialwin.cl"
                style={styles.button}
                onMouseOver={(e) => e.target.style.backgroundColor = '#FFD750'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#E6C148'}
              >
                Contáctanos
              </a>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default UnderConstructionPage;